export default "__VITE_ASSET__ByCWjRj___"